<template>
    <div class="mixology-header">
        <div class="mixology-header__title">
            <h1>mixology</h1>
        </div>

    </div>
</template>

<script>
import Lottie from "@/components/common/Lottie.vue";
import * as animationData from "@/assets/mixology/header/header.json";

export default {
    name: "mix-header",
    components: {
        Lottie
    },
    methods: {
        handleAnimation: function(anim) {
            this.anim = anim;
        }
    },
    data() {
        return {
            defaultOptions: { animationData: animationData }
        };
    }
};
</script>

<style lang="scss">
@import "./../../variables.scss";


.mixology-header {
    background-image: url(./../../assets/mixology/header/mixology-horizontal-header-mobile@2x.png);
    background-size: auto 100%;
    background-repeat: no-repeat;
    height: 59.467vw;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    width: 100%;
    overflow: hidden;
    padding: 0 15px;
    box-sizing: border-box;
    background-color: #61d1e5;

    @media (min-width: 768px) {
        background-image: url(./../../assets/mixology/header/mixology-horizontal-desktop-header-alt@2x.png);
        background-position: calc(50% + 50px) 50%;
        height: 220px;
        padding: 0 37px;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        top: 88px;
        z-index: 9;
    }

    .mixology-header__title {
        width: 100%;
        max-width: 768px;
        margin: 0 auto;
        
        h1{
            text-align: center;
            font-size: 11.2vw;
            font-weight: 600;

            @media (min-width: 768px) {
                margin: 0;
                text-align: left;
                font-size: 62px;
            }
        }
    }
}
// .mixology-header {
//     display: flex;
//     flex-direction: column;
//     align-items: flex-end;
//     width: 100%;
//     // height: 50vw;
//     overflow: hidden;
//     padding: 0 15px;
//     box-sizing: border-box;
//     background-color: $bubly-blue-light;

//     &__mix-mingle {
//         margin-top: 7px;
//         img {
//             max-width: 33.33%;
//         }
//     }

//     &__fizz-animation {
//         position: relative;
//         width: 100%;
//         height: 50%;

//         img {
//             position: absolute;
//             display: block;
//             left: 0;
//             right: 0;
//             bottom: -21px;
//         }
//     }

//     &__lottie {
//         margin-top: 40px;

//         .png {
//             opacity: 0;
//         }
//     }

//     @media (min-width: 768px) {
//         flex-direction: row;
//         justify-content: center;
//         height: 220px;
//         top: 88px;
//         z-index: 9;

//         &__mix-mingle {
//             width: 200px;
//             align-self: center;

//             img {
//                 max-width: 75%;
//             }
//         }
//         &__fizz-animation {
//             height: 100%;
//             max-width: 800px;
//         }
//     }
//     @media (min-width: 1200px) {
//         &__mix-mingle {
//             width: 250px;
//         }
//     }
//     .modal {
//         position: fixed;
//         padding-top: 50px;
//     }
//     #widget-modal .modal-body {
//         text-align: center;
//         width: 100%;
//         max-width: 840px;
//         min-width: 300px;
//         height: auto;
//         margin-left: auto;
//         margin-right: auto;
//         max-height: 750px !important;
//         padding: 0px;
//     }
//     .modal-open .modal {
//         background-color: rgba($color: #000000, $alpha: 0.6);
//     }
//     #widget-modal .close {
//         position: relative;
//         margin-right: -30px;
//         color: #fff;
//         margin-top: -30px;
//         font-size: 40px;
//         outline: 0;

//         &--mobile {
//             position: absolute;
//             margin: 0 auto;
//             top: 3px;

//             @media (min-width: 768px) {
//                 display: none;
//             }
//         }
//     }
//     #destinidiv {
//         background: #fff;
//         width: 100%;
//         overflow-y: auto;
//     }
// }
</style>


// WEBPACK FOOTER //
// src/components/mixology/MixHeader.vue